<script setup lang="ts">
import TheLayout from '@/modules/shared/layouts/the-layout.vue'
import { TheContent } from '@/modules/shared/components'
import IndividualHeaderV2 from '../individual-header-v2.vue'
import IndividualNavV2 from '../individual-nav-v2.vue'

type tabs =
  | 'account'
  | 'associated-entities'
  | 'esignatures'
  | 'files'
  | 'funds'
  | 'invoices'
  | 'notes'
  | 'overview'
  | 'portfolio'
  | 'spvs'
  | 'taxes'
  | 'permissions'

withDefaults(
  defineProps<{
    selectedTab: tabs
    disableSideSection?: boolean
  }>(),
  {
    disableSideSection: true,
  },
)
</script>

<template>
  <TheLayout>
    <IndividualHeaderV2>
      <template #actions>
        <slot name="actions"></slot>
      </template>
    </IndividualHeaderV2>
    <IndividualNavV2 :selectedTab="selectedTab" />
    <TheContent :disableSideSection="true">
      <template #main>
        <slot></slot>
      </template>
    </TheContent>
  </TheLayout>
</template>
